import { useEffect } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';

import { Button, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import Page from '...components/Page';
import { signIn } from '...contexts/Auth/providers/magicLink';
import useAuth from '...hooks/useAuth';
import LogoOnlyLayout from '...layouts/LogoOnlyLayout';
import { PATH_AUTH } from '...routes/paths';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function MagicLink() {
  const { register } = useAuth();
  const [search] = useSearchParams();

  useEffect(() => {
    if (!(register && search)) return;
    // Name and company.
    const n = search.get('n');
    const c = search.get('c');
    console.log('QUERY PARAMS?', { n, c });
    (async () => {
      if (n && c) {
        await register(signIn({ n, c }));
      } else {
        await signIn();
      }
    })();
  }, [register, search]);

  return (
    <Page title="Magic Link">
      <LogoOnlyLayout />

      <Container>
        <ContentStyle sx={{ textAlign: 'center' }}>
          <Typography variant="h3" paragraph>
            Magic Link
          </Typography>

          <Typography sx={{ color: 'text.secondary', mb: 5 }}>
            Please give us a moment while we log you in.
          </Typography>

          <Button fullWidth size="large" component={RouterLink} to={PATH_AUTH.login} sx={{ mt: 1 }}>
            Back
          </Button>
        </ContentStyle>
      </Container>
    </Page>
  );
}
